import { render, staticRenderFns } from "./RowBlockPaymentSystemCommissionLiqPay.vue?vue&type=template&id=bdb9d12a&"
import script from "./RowBlockPaymentSystemCommissionLiqPay.vue?vue&type=script&lang=js&"
export * from "./RowBlockPaymentSystemCommissionLiqPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports